// @ts-nocheck
/* Caroma Riviere launch page — scroll reveals, parallax, marquee, scrollytelling */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveal on scroll */
  var revealEls = document.querySelectorAll('.rvr-reveal, .rvr-stagger');
  if (reduced || !('IntersectionObserver' in window)) {
    revealEls.forEach(function (el) { el.classList.add('rvr-in'); });
  } else {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('rvr-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
    );
    revealEls.forEach(function (el) { io.observe(el); });
  }

  var scrolly = document.querySelector('.rvr-scrolly');

  if (reduced) {
    if (scrolly) scrolly.classList.add('rvr-scrolly--static');
    return;
  }

  /* Autoplay the launch film (muted) while it's in view; pause off-screen.
     Skipped for Save-Data users — they keep click-to-play. */
  var film = document.querySelector('.rvr-video video');
  var conn = navigator.connection;
  if (film && !(conn && conn.saveData) && 'IntersectionObserver' in window) {
    var filmIO = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (film.paused) {
              if (!film.dataset.rvrStarted) {
                film.muted = true;
                film.dataset.rvrStarted = '1';
              }
              if (film.ended) film.currentTime = 0;
              var p = film.play();
              if (p && p.catch) p.catch(function () {});
            }
          } else if (!film.paused) {
            film.pause();
          }
        });
      },
      { threshold: 0.5 }
    );
    filmIO.observe(film);
  }

  /* Parallax layers */
  var items = Array.prototype.slice
    .call(document.querySelectorAll('[data-rvr-px]'))
    .map(function (el) {
      return {
        el: el,
        speed: parseFloat(el.getAttribute('data-rvr-px')) || 0.15,
        box: el.parentElement || el
      };
    });

  /* Kinetic marquee */
  var marquees = Array.prototype.slice
    .call(document.querySelectorAll('[data-rvr-mq]'))
    .map(function (el) {
      return { el: el, speed: parseFloat(el.getAttribute('data-rvr-mq')) || 0.18 };
    });

  /* Hero content drift/fade */
  var heroContent = /** @type {HTMLElement|null} */ (document.querySelector('.rvr-hero__content'));

  /* Scrollytelling */
  var scrollyImgs = scrolly ? Array.prototype.slice.call(scrolly.querySelectorAll('.rvr-scrolly__img')) : [];
  var scrollyCaps = scrolly ? Array.prototype.slice.call(scrolly.querySelectorAll('.rvr-scrolly__caption')) : [];
  var scrollyDots = scrolly ? Array.prototype.slice.call(scrolly.querySelectorAll('.rvr-scrolly__dots span')) : [];
  var scrollyStep = -1;

  var vh = window.innerHeight;
  var narrow = window.innerWidth < 750;
  var ticking = false;

  /** @param {number} idx */
  function setStep(idx) {
    if (idx === scrollyStep) return;
    scrollyStep = idx;
    scrollyImgs.forEach(function (img, i) { img.classList.toggle('is-active', i === idx); });
    scrollyCaps.forEach(function (cap, i) { cap.classList.toggle('is-active', i === idx); });
    scrollyDots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === idx); });
  }

  function update() {
    ticking = false;

    items.forEach(function (it) {
      var rect = it.box.getBoundingClientRect();
      if (rect.bottom < -80 || rect.top > vh + 80) return;
      var progress = rect.top + rect.height / 2 - vh / 2;
      var speed = narrow ? it.speed * 0.55 : it.speed;
      var bleed = Math.max(0, (it.el.offsetHeight - rect.height) / 2);
      var ty = Math.max(-bleed, Math.min(bleed, -progress * speed));
      it.el.style.transform = 'translate3d(0,' + ty.toFixed(1) + 'px,0)';
    });

    marquees.forEach(function (mq) {
      var rect = mq.el.parentElement.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > vh) return;
      var tx = (rect.top - vh) * mq.speed * (narrow ? 1.6 : 1);
      mq.el.style.transform = 'translate3d(' + tx.toFixed(1) + 'px,0,0)';
    });

    if (heroContent) {
      var y = window.scrollY || window.pageYOffset;
      var p = Math.min(1, Math.max(0, y / (vh * 0.7)));
      heroContent.style.opacity = String(1 - p * 0.9);
      heroContent.style.transform = 'translate3d(0,' + (p * 46).toFixed(1) + 'px,0)';
    }

    if (scrolly && scrollyImgs.length) {
      var rect2 = scrolly.getBoundingClientRect();
      var total = rect2.height - vh;
      if (rect2.top <= 0 && rect2.bottom >= vh && total > 0) {
        var prog = Math.min(0.999, Math.max(0, -rect2.top / total));
        setStep(Math.floor(prog * scrollyImgs.length));
      } else if (rect2.top > 0) {
        setStep(0);
      } else if (rect2.bottom < vh) {
        setStep(scrollyImgs.length - 1);
      }
    }
  }

  function requestTick() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }

  window.addEventListener('scroll', requestTick, { passive: true });
  window.addEventListener('resize', function () {
    vh = window.innerHeight;
    narrow = window.innerWidth < 750;
    requestTick();
  });
  update();
})();
